import React from 'react'
import { STEP_TYPE_ENUM } from 'services/api/constants'
import { TaskState } from 'state/tasks'
import styled from 'particles/themes/styled'
import { theme } from 'theme'
import AttendEvent from './AttendEvent'
import PurchaseProduct from './PurchaseProduct'
import SubmitProofPhoto from './SubmitProofPhoto'

interface StepsEditorProps {
    task: TaskState
    requiredFieldNames: { [key: string]: string[] }
    includedSteps: { [stepType: string]: boolean }
    toggleIncludedStep: (stepType: STEP_TYPE_ENUM, isToggled: boolean) => void
    className?: string
    showBrief?: boolean
}

const StepsEditor: React.FC<StepsEditorProps> = ({
    task,
    requiredFieldNames,
    className,
    includedSteps,
    toggleIncludedStep,
    showBrief,
}) => {
    return (
        <div className={className}>
            {task.steps.map((step, index) => {
                const requiredFields = showBrief ? [] : requiredFieldNames[step.type]

                switch (step.type) {
                    case STEP_TYPE_ENUM.ATTEND_EVENT:
                        return (
                            <AttendEvent
                                key={step.uuid}
                                uuid={step.uuid}
                                taskType={task.type}
                                stepType={step.type}
                                stepNumber={index + 1}
                                requiredFieldNames={requiredFields}
                            />
                        )
                    case STEP_TYPE_ENUM.PURCHASE_PRODUCT:
                        return (
                            <PurchaseProduct
                                key={step.uuid}
                                uuid={step.uuid}
                                taskType={task.type}
                                stepType={step.type}
                                stepNumber={index + 1}
                                requiredFieldNames={requiredFields}
                            />
                        )
                    case STEP_TYPE_ENUM.SUBMIT_PROOF_PHOTO:
                        return (
                            <SubmitProofPhoto
                                key={step.uuid}
                                uuid={step.uuid}
                                taskType={task.type}
                                stepType={step.type}
                                stepNumber={index + 1}
                                requiredFieldNames={requiredFields}
                                isIncluded={includedSteps[STEP_TYPE_ENUM.SUBMIT_PROOF_PHOTO]}
                                toggleIncludedStep={toggleIncludedStep}
                                showBrief={showBrief}
                            />
                        )
                    default:
                        return <></>
                }
            })}
        </div>
    )
}

export default styled(StepsEditor)`
    width: 100%;
    display: flex;
    gap: ${theme.newSpacing.l};
    flex-direction: column;
    height: fit-content;
`
